var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.667 2.667v26.666h26.666",
    stroke: "url(#status_svg__mobile-paint0_linear)",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#status_svg__mobile-paint1_linear)",
    strokeWidth: 1.6,
    strokeLinecap: "square",
    d: "M9.867 23.2V12.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#status_svg__mobile-paint2_linear)",
    strokeWidth: 1.6,
    strokeLinecap: "square",
    d: "M16.533 23.2V4.8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#status_svg__mobile-paint3_linear)",
    strokeWidth: 1.6,
    strokeLinecap: "square",
    d: "M23.2 23.2v-6.4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "status_svg__mobile-paint0_linear",
    x1: 2.667,
    y1: 29.333,
    x2: 34.699,
    y2: 18.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "status_svg__mobile-paint1_linear",
    x1: 11.667,
    y1: 24,
    x2: 7.951,
    y2: 23.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "status_svg__mobile-paint2_linear",
    x1: 18.333,
    y1: 24,
    x2: 14.478,
    y2: 23.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "status_svg__mobile-paint3_linear",
    x1: 25,
    y1: 24,
    x2: 21.529,
    y2: 22.725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3D9CAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#779AF7"
  })))));
}

export default SvgStatus;